export const contentServices = {
  abonimentServices: [
    {
      name: "Гончарство",
      description:
        "На заняттях з гончарства ми знайомимо діточок з властивостями глини, навчаємо прийомам ліплення і формоутворення, знайомимо з роботою за гончарним колом.",
      price: "300 грн",
      priceOnce: "300 грн",
    },
    {
      name: "Ліплення",
      description:
        "На заняттях з ліплення ми знайомимо діточок з властивостями глини, навчаємо прийомам ліплення і формоутворення, знайомимо з роботою за гончарним колом.",
      price: "250 грн ",
      priceOnce: "250 грн",
    },
    {
      name: "Малювання",
      description:
        "Заняття з малюнку і живопису розкривають діткам секрети кольорів і їх поєднання, навчають помічати красу навколо і передавати у своїх роботах.",
      price: "200 грн",
      priceOnce: "200 грн",
    },
    {
      name: "Аплікація-оригамі",
      description:
        "Заняття аплікацією-оригамі розвивають моторику та творче мислення, поєднуючи мистецтво складання паперу і аплікації у захопливі уроки.",
      price: "200 грн",
      priceOnce: "200 грн",
    },
  ],

  masterClassPottery: [
    {
      name: "Для двох",
      age: "Для дорослих",
      description:
        "Запрошуємо вас та вашого партнера до нашої чарівної гончарної студії! Приєднуйтесь до нашого захоплюючого майстер-класу, де ви зможете самостійно ліпити та робити казкові вироби за гончарним колом. Перетворіть глину в чарівні форми, які будуть обпалюватися і надсилатися до вас! Творчий процес займе лише 1-1,5 години, а ви отримаєте неймовірне задоволення та навички роботи з гончарною глиною. А якщо ви хочете додатково підкреслити свій виріб, з радістю надамо можливість покрити його чарівними поливами!",
      price: "2000 грн",
    },
    {
      name: "Група від 3 людей",
      age: "Для дорослих",
      description:
        "Ласкаво просимо до нашої чарівної гончарної студії! Приєднуйтесь до нашого захоплюючого майстер-класу, де ви зможете самостійно ліпити та робити казкові вироби за гончарним колом. Перетворіть глину в чарівні форми, які будуть обпалюватися і надсилатися до вас! Творчий процес займе лише 1-1,5 години,ви отримаєте неймовірне задоволення та навички роботи з гончарною глиною. А якщо ви хочете додатково підкреслити свій виріб, з радістю надамо можливість покрити його чарівними поливами!",
      price: "800 грн",
    },
    {
      name: "Група від 10 людей ",
      age: "Для дорослих",
      description:
        "Ласкаво просимо до нашої чарівної гончарної студії! Приєднуйтесь до нашого захоплюючого майстер-класу, де ви зможете самостійно ліпити та робити казкові вироби за гончарним колом. Перетворіть глину в чарівні форми, які будуть обпалюватися і надсилатися до вас! Творчий процес займе лише 1-1,5 години ви отримаєте неймовірне задоволення та навички роботи з гончарною глиною. А якщо ви хочете додатково підкреслити свій виріб, з радістю надамо можливість покрити його чарівними поливами!",
      price: "600 грн",
    },
    {
      name: "Група від 5 дітей ",
      description:
        "Ласкаво просимо до нашої чарівної гончарної студії! Приєднуйтесь до нашого захоплюючого майстер-класу, де ви зможете самостійно ліпити та робити казкові вироби за гончарним колом. Перетворіть глину в чарівні форми, які будуть обпалюватися і надсилатися до вас! Творчий процес займе лише 1-1,5 години,ви отримаєте неймовірне задоволення та навички роботи з гончарною глиною. А якщо ви хочете додатково підкреслити свій виріб, з радістю надамо можливість покрити його чарівними поливами!",
      price: "500 грн",
      age: "Для дітей",
    },
    {
      name: "Група від 10 дітей ",
      description:
        "Ласкаво просимо до нашої чарівної гончарної студії! Приєднуйтесь до нашого захоплюючого майстер-класу, де ви зможете самостійно ліпити та робити казкові вироби за гончарним колом. Перетворіть глину в чарівні форми, які будуть обпалюватися і надсилатися до вас! Творчий процес займе лише 1-1,5 години,ви отримаєте неймовірне задоволення та навички роботи з гончарною глиною. А якщо ви хочете додатково підкреслити свій виріб, з радістю надамо можливість покрити його чарівними поливами!",
      price: "300 грн",
      age: "Для дітей",
    },
  ],
  masterClassPainting: [
    {
      name: "Для двох",
      age: "Для дорослих",
      description:
        "Запрошуємо вас та вашого партнера на захоплюючі заняття малювання акриловими фарбами! Разом ви зможете розпалити свою творчість та втілити унікальні ідеї на полотні. Після висихання, ваші шедеври будуть стійкими до вологи, що збереже їх красу на довгий час. Вартість включає грунтоване полотно на підрамнику, що зробить ваші заняття ще зручнішими. Приходьте разом і зануртесь у світ мистецтва та відкрийте нові горизонти у малюванні! Очікуємо вас з нетерпінням на наших заняттях!. Тривалість заняття 2 години.",
      price: "2000 грн",
    },
    {
      name: "Група від 3 людей і більше",
      age: "Для дорослих",
      description:
        "Запрошуємо вас та вашу дружню компанію на захоплюючі заняття малювання акриловими фарбами! Створення неповторних шедеврів, творчий процес та радісна атмосфера чекають на вас. Проведіть час весело та корисно, розкривайте свій творчий потенціал разом з друзями. Наші професійні викладачі допоможуть вам крок за кроком освоїти техніки малювання акрилом. Вартість включає грунтоване полотно на підрамнику, що зробить ваші заняття ще зручнішими. Очікуємо вас з нетерпінням на наших заняттях!. Тривалість заняття 2 години.",
      price: "800 грн",
    },
    {
      name: "Група від 5 дітей і більше",
      description:
        "Запрошуємо вас та вашу дружню компанію на захоплюючі заняття малювання акриловими фарбами! Створення неповторних шедеврів, творчий процес та радісна атмосфера чекають на вас. Проведіть час весело та корисно, розкривайте свій творчий потенціал разом з друзями. Наші професійні викладачі допоможуть вам крок за кроком освоїти техніки малювання акрилом. Вартість включає грунтоване полотно на підрамнику, що зробить ваші заняття ще зручнішими. Очікуємо вас з нетерпінням на наших заняттях!. Тривалість заняття 2 години.",

      price: "250 грн",
      age: "Для дітей",
    },
  ],
  onlineServices: [
    {
      name: "В групі для дітей",
      description:
        "Малювання фарбами гуаш. Фарби відомі та широко використовуються під час творчості професійних художників. Тривалітсь заняття 1 година.",
      price: "100 грн / година",
    },
    {
      name: "В групі для дорослих",
      description:
        "Малювання фарбами гуаш. Фарби відомі та широко використовуються під час творчості професійних художників. Тривалітсь заняття 1 година.",
      price: "500 грн / година",
    },
    {
      name: "Індивідуальне для дітей",
      description:
        "Малювання фарбами гуаш індивідуально. Онлайн заняття - це чудова можливість для тих, хто хоче отримувати задоволення від занять з малюнку та живопису, не відвідуючи студію. Багато наших діток, що зараз знаходяться за кордоном, мають можливість продовжувати навчання. Тривалітсь заняття 1 година.",
      price: "400 грн / година",
    },
    {
      name: "Індивідуальне для дорослих",
      description:
        "Малювання фарбами гуаш індивідуально. Онлайн заняття - це чудова можливість для тих, хто хоче отримувати задоволення від занять з малюнку та живопису, не відвідуючи студію. Багато наших діток, що зараз знаходяться за кордоном, мають можливість продовжувати навчання. Тривалітсь заняття 1 година.",
      price: "800 грн / година",
    },
  ],
};
